export { YES, NO } from './yesNo';

export const UNKNOWN = { id: 'unknown', label: 'Non noto/Non dichiarato' };
